import { loadStripe } from '@stripe/stripe-js';
import type { Stripe, Appearance } from '@stripe/stripe-js';

/**
 * loadStripe injects a script tag, so calling it per render would reload
 * Stripe.js and tear down any mounted Elements. Cache one promise per
 * publishable key — the key differs between the platform account and a
 * boutique's own account.
 */
const clients = new Map<string, Promise<Stripe | null>>();

export function getStripe(publishableKey: string): Promise<Stripe | null> {
  let client = clients.get(publishableKey);
  if (!client) {
    client = loadStripe(publishableKey);
    clients.set(publishableKey, client);
  }
  return client;
}

/** Matches the app's rounded, purple-accented form styling. */
export const STRIPE_APPEARANCE: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#a855f7',
    colorText: '#1a1a2e',
    colorDanger: '#ef4444',
    fontFamily: '"Inter", system-ui, sans-serif',
    borderRadius: '12px',
    spacingUnit: '4px',
  },
  rules: {
    '.Input': {
      border: '1px solid #e5e7eb',
      boxShadow: 'none',
      padding: '12px',
    },
    '.Input:focus': {
      border: '1px solid #a855f7',
      boxShadow: '0 0 0 3px rgba(168, 85, 247, 0.15)',
    },
    '.Label': {
      fontWeight: '500',
      color: '#4b5563',
    },
  },
};
